import * as zoid from "@krakenjs/zoid/dist/zoid.frameworks.js";

export const PreviewTemplatesEditor = zoid.create({
  tag: "preview-templates-editor",
  url: `${SERVER_URL}/preview-templates-editor`,
  dimensions: {
    width: "100%",
    height: "100%",
  },
});
